import React from 'react';
import { Link } from 'react-router-dom';
import CrushShyPageHead from '../../components/CrushShyPageHead';
import { crushshySeo } from '../../seo/crushshySeo';
import { useLanguage } from '../../context/LanguageContext';
import { useCrushShyT } from '../../hooks/useCrushShyT';

const { landing } = crushshySeo;

const CrushShyLanding = () => {
  const t = useCrushShyT();
  const { toggleLanguage } = useLanguage();

  return (
    <>
      <CrushShyPageHead title={landing.title} description={landing.description} path={landing.path} />
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'MobileApplication',
            name: 'CrushShy',
            operatingSystem: 'iOS, Android',
            applicationCategory: 'SocialNetworkingApplication',
            description: landing.description,
            url: 'https://loranrix.com/crushshy',
            offers: { '@type': 'Offer', price: '0', priceCurrency: 'EUR' },
          }),
        }}
      />
      <div className="min-h-screen bg-[#090B16] text-white">
        <header className="px-6 py-6 max-w-3xl mx-auto flex items-center justify-between">
          <Link to="/" className="text-sm text-pink-400/90 hover:text-pink-300">
            Loranrix
          </Link>
          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={toggleLanguage}
              className="text-xs font-semibold px-2.5 py-1 rounded-md border border-pink-500/30 text-pink-300 hover:bg-pink-500/10"
            >
              {t('langToggle')}
            </button>
            <span className="text-xs font-bold uppercase tracking-widest text-pink-400">CrushShy</span>
          </div>
        </header>

        <main className="px-6 pb-16 max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold leading-tight mb-4 bg-gradient-to-r from-pink-400 to-purple-400 bg-clip-text text-transparent">
            {t('landingTitle')}
          </h1>
          <p className="text-lg text-gray-300 mb-8 leading-relaxed">{t('landingLead')}</p>

          <ul className="space-y-3 text-gray-400 text-sm mb-10">
            <li>📍 {t('landingBullet1')}</li>
            <li>💕 {t('landingBullet2')}</li>
            <li>🔒 {t('landingBullet3')}</li>
          </ul>

          <p className="text-white font-semibold mb-3">{t('landingDownload')}</p>
          <p className="text-sm text-gray-500 mb-8">{t('landingStore')}</p>

          <nav className="flex flex-wrap gap-4 text-sm" aria-label="CrushShy legal pages">
            <Link to="/crushshy/privacy" className="text-pink-400 hover:underline">
              {t('landingPrivacy')}
            </Link>
            <Link to="/crushshy/terms" className="text-pink-400 hover:underline">
              {t('landingTerms')}
            </Link>
            <Link to="/" className="text-gray-500 hover:text-gray-300">
              {t('landingLoranrix')}
            </Link>
          </nav>
        </main>
      </div>
    </>
  );
};

export default CrushShyLanding;
